import {StateLabel} from '@primer/react'
import {useMemo} from 'react'
import {clsx} from 'clsx'
import {STATE_LABEL_DATA, type PullRequestState as PullRequestStateType} from '../types'

interface PullRequestStateLabelProps {
  className?: string
  state: PullRequestStateType
}

export function PullRequestStateLabel({className, state}: PullRequestStateLabelProps) {
  const stateLabel = useMemo(() => STATE_LABEL_DATA[state], [state])

  return (
    <StateLabel className={clsx('flex-self-start', className)} status={stateLabel.status}>
      {stateLabel.description}
    </StateLabel>
  )
}
